//地理位置处理
import jsonPloader from "If_AdTool/common/JsonpLoader";
import sdkTool from "If_AdTool/common/sdkTool";
const URL = "https://region.ifeng.com/get?format=js";
/***
 * 不要删，主站在用这个服务判断地域
 * ***/
let region =  {
    isIfeng:function(){
        return window.location.hostname.indexOf("ifeng.com")!=-1
    },
    init:function(){
        if (typeof (regionOrientProv) == 'undefined') {
            let regionVer = '1.2';
            //get the region cookie
            let regionOrientProv = sdkTool.cookie('prov');
            let regionOrientCity = sdkTool.cookie('city');
            // let regionOrientNewProv = sdkTool.cookie('if_prov');
            // let regionOrientNewCity = sdkTool.cookie('if_city');
            let regionOrientWeatherCity = sdkTool.cookie('weather_city');
            let regionOrientIP = sdkTool.cookie('region_ip');
            let regionOrientVersion = sdkTool.cookie('region_ver');
            if (this.isIfeng()) {
                sdkTool.cookie("ifprov", null, { domain: "ifeng.com" });
                sdkTool.cookie("ifcity", null, { domain: "ifeng.com" });
                // sdkTool.cookie("if_prov", null, { domain: "ifeng.com" });
                // sdkTool.cookie("if_city", null, { domain: "ifeng.com" });
                sdkTool.cookie("prov", null);
                sdkTool.cookie("city", null);
                sdkTool.cookie("weather_city", null);
                sdkTool.cookie("region_ip", null);
                sdkTool.cookie("region_ver", null);
            }
            if (regionOrientProv == null || regionOrientCity == null || regionOrientWeatherCity == null || regionOrientIP==null||  regionOrientVersion != regionVer) {
                jsonPloader.getJsonP(URL, "callback", (locationStr) => {
                    let COOKIE_EXPIRES = 43200;
                    let regionArray = locationStr.split("[");
                    let regionStr = regionArray[0].slice(0, -1);
                    let regionTempArray = regionStr.split("_");
                    let regionProv = regionTempArray[0];
                    let regionCity = regionTempArray[1];
                    let regionWeatherCity = regionArray[1].slice(0, -1);
                    let regionIP = regionArray[2].slice(0, -1);
                    regionIP = regionIP.substring(0, regionIP.lastIndexOf(".")) + ".x";
                    let option = {
                        expires: COOKIE_EXPIRES,
                        path:'/'
                    }
                    if (this.isIfeng()) {
                        option.domain="ifeng.com";
                    }
                    sdkTool.cookie('if_prov', regionProv, option);
                    sdkTool.cookie('if_city', regionCity, option);
                    
                    sdkTool.cookie('prov', regionProv, option);
                    sdkTool.cookie('city', regionCity, option);
                    sdkTool.cookie('weather_city', regionWeatherCity, option);
                    sdkTool.cookie('region_ip', regionIP, option);
                    sdkTool.cookie('region_ver', regionVer, option);
                })
            } else {}

        }
    }
}
export default region;